/* eslint-disable */
// source: vivacity/core/image_degradation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.vivacity.core.ImageDegradation', null, global);
goog.exportSymbol('proto.vivacity.core.ImageDegradationType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.ImageDegradation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.core.ImageDegradation.repeatedFields_, null);
};
goog.inherits(proto.vivacity.core.ImageDegradation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.ImageDegradation.displayName = 'proto.vivacity.core.ImageDegradation';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.core.ImageDegradation.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.ImageDegradation.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.ImageDegradation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.ImageDegradation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.ImageDegradation.toObject = function(includeInstance, msg) {
  var f, obj = {
    imageDegradationTypeList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.ImageDegradation}
 */
proto.vivacity.core.ImageDegradation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.ImageDegradation;
  return proto.vivacity.core.ImageDegradation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.ImageDegradation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.ImageDegradation}
 */
proto.vivacity.core.ImageDegradation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.vivacity.core.ImageDegradationType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addImageDegradationType(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.ImageDegradation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.ImageDegradation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.ImageDegradation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.ImageDegradation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getImageDegradationTypeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated ImageDegradationType image_degradation_type = 1;
 * @return {!Array<!proto.vivacity.core.ImageDegradationType>}
 */
proto.vivacity.core.ImageDegradation.prototype.getImageDegradationTypeList = function() {
  return /** @type {!Array<!proto.vivacity.core.ImageDegradationType>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.vivacity.core.ImageDegradationType>} value
 * @return {!proto.vivacity.core.ImageDegradation} returns this
 */
proto.vivacity.core.ImageDegradation.prototype.setImageDegradationTypeList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.vivacity.core.ImageDegradationType} value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.ImageDegradation} returns this
 */
proto.vivacity.core.ImageDegradation.prototype.addImageDegradationType = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.ImageDegradation} returns this
 */
proto.vivacity.core.ImageDegradation.prototype.clearImageDegradationTypeList = function() {
  return this.setImageDegradationTypeList([]);
};


/**
 * @enum {number}
 */
proto.vivacity.core.ImageDegradationType = {
  IMAGE_DEGRADATION_TYPE_UNKNOWN: 0,
  IMAGE_DEGRADATION_TYPE_NONE: 1,
  IMAGE_DEGRADATION_TYPE_GLARE: 2,
  IMAGE_DEGRADATION_TYPE_SENSOR_SLIP: 3
};

goog.object.extend(exports, proto.vivacity.core);
